import { render, staticRenderFns } from "./StudentPhotoCard.vue?vue&type=template&id=501daad0&scoped=true"
import script from "./StudentPhotoCard.vue?vue&type=script&lang=js"
export * from "./StudentPhotoCard.vue?vue&type=script&lang=js"
import style0 from "./StudentPhotoCard.vue?vue&type=style&index=0&id=501daad0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501daad0",
  null
  
)

export default component.exports